/**
 * Shared pagination helper for API modules. Exposes fetchPaginatedItems,
 * which serializes PaginationQueryParams (page/perPage plus any extra
 * filters) into a query string and GETs a PaginatedResponse<T> from either
 * the main backend (api) or the AI service (aiApi), selected via ApiService.
 * Used by the admin, bounty, userBounty, userBountySubmission,
 * userSubmission, userPayment, and userPursuit API modules.
 */
import { api, aiApi } from "@/lib/axios";
import { PaginatedResponse } from "@/types/pagination";

export interface PaginationQueryParams {
    page?: number;
    perPage?: number;
}

export enum ApiService {
    API = "api",
    AI = "ai",
}

export async function fetchPaginatedItems<T>(
    endpoint: string,
    params: PaginationQueryParams = {},
    api_service: ApiService = ApiService.API
): Promise<PaginatedResponse<T>> {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            queryParams.append(key, value.toString());
        }
    });

    const url = `${endpoint}?${queryParams.toString()}`;

    // AI service endpoints are hit by the aiApi
    if (api_service === ApiService.AI) {
        const { data } = await aiApi.get<PaginatedResponse<T>>(url);
        return data;
    }
    const { data } = await api.get<PaginatedResponse<T>>(url);
    return data;
}
